import {
  Avatar,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { BsTrophy } from "react-icons/bs";
import { GrHistory } from "react-icons/gr";
import { RiEyeLine, RiSearch2Line } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import { AssignBadgeModal } from "../../components/admin/badges/AssignBadgeModal";
import Loading from "../../components/common/Loading";
import { ForceEnrolmentModal } from "../../components/trainee/enrolment/ForceEnrolmentModal";
import { IUserProfile } from "../../models/admin/user.model";
import adminHelpers from "../../services/admin/admin.service";
import { getFullDate } from "../../utils/classOfDegree";
import Adminroutes from "./routes";

const AdminTrainees = () => {
  const navigate = useNavigate();
  const [gender, setGender] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [traineeId, setTraineeId] = useState("");
  const [allTrainees, setAllTrainees] = useState<IUserProfile[]>([]);
  const [fileteredTrainees, setFilteredTrainees] = useState<IUserProfile[]>([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [isEnrol, setEnrol] = useState(false);
  const [isAssign, setIsAssign] = useState(false);
  const [viewProfleHistory, setViewProfileHistory] = useState(false);
  const [reload, setReload] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectTrainee, setSelectTrainee] = useState<IUserProfile>();

  useEffect(() => {
    adminHelpers.getTrainees().then((res) => {
      const approvedtrainees = res.data.filter(
        (each) => each.approval_status == "Approved"
      );
      setAllTrainees(approvedtrainees);
      setFilteredTrainees(approvedtrainees);
      setLoading(false);
    });

    const maingender = [
      {
        id: "1",
        title: "Technical",
      },
      {
        id: "2",
        title: "Non-Technical",
      },
    ];
    setGender(maingender);
  }, []);

  const openEnrolModal = async (id: string) => {
    setEnrol(true);
    setIsAssign(false);
    onOpen();
    setTraineeId(id);
    setViewProfileHistory(false);
  };

  const assignBadge = (trainee: IUserProfile) => {
    setSelectTrainee(trainee);
    setIsAssign(true);
    setEnrol(false);
    setViewProfileHistory(false);
    onOpen();
  };

  const reloadData = () => {
    setReload(!reload);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredTrainees(allTrainees);
    } else {
      if (allTrainees) {
        const filtered = allTrainees.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredTrainees(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  const viewTrainee = async (trainee_id: string) => {
    navigate(Adminroutes.ReviewTraineeLink(trainee_id));
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["4rem", "4rem", "4rem", "25%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>

          <Box width="100%">
            <AdminDashboardHeader />
            <Box
              pt="30px"
              pb="40px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"100%"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowY={"scroll"}
              // className="scroll-hidden"
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Trainees
                </Box>
              </Flex>
              <Flex py="15px" justifyContent="">
                <InputGroup
                  color="brand.subtitle"
                  bg="white"
                  width={["100%", "100%", "50%", "30%"]}
                >
                  <Input
                    height="40px"
                    placeholder="Search trainees by name"
                    onChange={(e) => handleSearchChange(e)}
                    fontSize={12}
                    size="sm"
                  />

                  <InputRightElement
                    pointerEvents="none"
                    children={<RiSearch2Line color="red" size="0.9rem" />}
                  />
                </InputGroup>
              </Flex>
              <Box width="100%" >
                <TableContainer               overflowX={"scroll"} className="scroll-hidden">
                  <Table variant="simple">
                    <Thead mb="10px">
                      <Tr
                        pb="10px"
                        borderBottom="1px solid"
                        borderColor="#D5D5D5"
                      >
                        {/* <Th width="70px">
                          <Checkbox></Checkbox>
                        </Th> */}
                        <Th textTransform="none">Trainee</Th>
                        <Th textTransform="none">Trainee ID</Th>
                        <Th textTransform="none">Courses</Th>
                        <Th textTransform="none">Date Joined</Th>
                        <Th textTransform="none">Email Address</Th>
                        <Th textTransform="none">Options</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {fileteredTrainees.map((each) => (
                        <Tr bg="white" key={each.id}>
                          {/* <Td width="70px">
                            <Checkbox></Checkbox>
                          </Td> */}
                          <Td>
                            <HStack spacing="10px">
                              <Avatar name={each.name} size="sm" />
                              <Text
                                fontWeight="600"
                                fontSize="16px"
                                color="#616161"
                              >
                                {each.name}
                                <br></br>
                                {/* Mechanical Engineering */}
                              </Text>
                            </HStack>
                          </Td>
                          <Td>
                            {" "}
                            <Text>{each.code ? each.code : ""}</Text>
                          </Td>
                          <Td>
                            {" "}
                            <Text textAlign={"center"}>{"1"}</Text>
                          </Td>
                          <Td>
                            {" "}
                            <Text>{getFullDate(each.created_at)}</Text>
                          </Td>
                          <Td>
                            <Text>{each.email}</Text>
                          </Td>

                          <Td>
                            <HStack>
                              <Button
                                size={"sm"}
                                fontSize={"12px"}
                                colorScheme="red"
                                variant={"outline"}
                                borderColor={"white"}
                                onClick={() => {
                                  openEnrolModal(each.uuid);
                                }}
                              >
                                Enrol
                              </Button>
                              <Center
                                cursor={"pointer"}
                                border="1px solid"
                                borderRadius="10px"
                                onClick={() => {
                                  viewTrainee(each.uuid);
                                }}
                                borderColor="#E5E5E5"
                                width="30px"
                                height="30px"
                                title="view profile"
                              >
                                <RiEyeLine />
                              </Center>
                              <Center
                                border="1px solid"
                                borderRadius="10px"
                                onClick={() => {
                                  assignBadge(each);
                                }}
                                cursor={"pointer"}
                                borderColor="#E5E5E5"
                                width="30px"
                                height="30px"
                                title="assign badge to trainee"
                              >
                                <BsTrophy />
                              </Center>
                              <Link
                                to={`/admin/profile-history/${each.id}?name=${each.name}`}
                              >
                                <Center
                                  border="1px solid"
                                  borderRadius="10px"
                                  cursor={"pointer"}
                                  borderColor="#E5E5E5"
                                  width="30px"
                                  height="30px"
                                  title="view profile update history"
                                >
                                  <GrHistory />
                                </Center>
                              </Link>
                            </HStack>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Box>
          {isEnrol && (
            <Portal>
              {" "}
              <ForceEnrolmentModal
                isOpen={isOpen}
                onClosed={onClose}
                isEnrol={isEnrol}
                reload={reloadData}
                data={traineeId}
              />{" "}
            </Portal>
          )}
          {isAssign && (
            <Portal>
              {" "}
              <AssignBadgeModal
                isOpenAssignBadge={isOpen}
                onClosed={onClose}
                isAssignBadge={isAssign}
                reload={reloadData}
                trainee={selectTrainee}
              />{" "}
            </Portal>
          )}
        </Flex>
      )}
    </>
  );
};

export default AdminTrainees;
